import { withComponentCapabilities } from "../capabilities/componentCapabilities";
import CustomForm from "../CustomForm";
import { buildData } from "./chartUtils";
import PropTypes from 'prop-types';

/**
 * A dynamic data display component that is the text dual of a visual chart
 * @component
 */
const DynamicPanel = withComponentCapabilities(({ panel, data }) => {
    const panelData = buildData(data, panel.query, panel.groupBy, panel.collation, panel.sort, panel.mapping);
    return <div className="w-100 h-100">
        <CustomForm def={panel.def} data={panelData} disabled={true} readonly={true} onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }} style={{ overflow: 'auto', width: '100%', height: '100%' }}></CustomForm>
    </div>
}, {
    lazyProps: ['data']
});

DynamicPanel.propTypes = {
    /**
     * The panel configuration
     */
    panel: PropTypes.object.isRequired,
    /**
     * The data to be rendered by the panel
     */
    data: PropTypes.array
}

export default DynamicPanel;